import { ListItem, ListItemIcon, ListItemText, Collapse, List } from "@material-ui/core";
import { useState, useEffect } from "react";
import { ArrowDropUp, ArrowDropDown } from "@material-ui/icons";

export default function CollapsibleListItem({ title, listItems, includeParent, labelKey, childKey, listItemClassName, onClick, AddOn, ...additionProps }) {
    const [expanded, handleDropDown] = useState(false);
    return (<>
        <ListItem
            button
            onClick={() => {
                handleDropDown(!expanded);
            }}
            className={listItemClassName}
        >
            {AddOn &&
                (<AddOn additionProps={additionProps} />)
            }
            <ListItemText primary={title} />
            {expanded ? <ArrowDropUp /> : <ArrowDropDown />}
        </ListItem>

        <Collapse in={expanded} timeout="auto" unmountOnExit>
            <List component="div" disablePadding>
                {[...(includeParent ? [{ ...additionProps, [childKey]: title }, ...listItems] : listItems)].map(item => (
                    <ListItem onClick={() => onClick(item)} button className={`pl-30 ${listItemClassName || ''}`}>
                        {AddOn ?
                            (<AddOn additionProps={additionProps} />) :
                            null
                        }
                        <ListItemText primary={labelKey ? item[labelKey] : title == item[childKey] ? title : `${title} - ${item[childKey]}`} />
                    </ListItem>
                ))}
            </List>
        </Collapse>
    </>)
}
